/* Inside Line custom PDP — split from product-page.html */
(function(){
  document.documentElement.classList.add('js');

  /* ---------- Data (from brief; Shopify variant IDs) ---------- */
  var CDN = 'https://cdn.shopify.com/s/files/1/0664/9374/3189/files/inside-line-tracing-projector-';
  var IMAGES = [
    {n:'01', alt:'Inside Line tracing projector on an adjustable arm projecting a flower design onto paper while a hand traces the lines'},
    {n:'02', alt:'Side-by-side comparison of tracing with the Inside Line projector versus drawing a flower with the grid method'},
    {n:'03', alt:'Close-up of a pencil tracing projected peony outlines on paper'},
    {n:'04', alt:"What's included: projector, adjustable arm, weighted base, power adapter and user guide"},
    {n:'05', alt:'30-day money-back guarantee with the projector on a desk beside a finished flower drawing'},
    {n:'06', alt:'Mother and son at a kitchen table while the child traces a projected puppy drawing'},
    {n:'07', alt:'Projector shining a flower design onto a large sugar cookie while icing is piped over the lines'}
  ];
  var PACKS = {
    '1': {id:42994645827669, name:'1 Pack', price:99.99,  compare:119.99},
    '2': {id:42994645860437, name:'2 Pack', price:159.99, compare:199.98},
    '3': {id:42994645893205, name:'3 Pack', price:224.99, compare:299.97}
  };
  var ANGLES = {
    cookies: {headline:'Pipe the design the way decorators do: project it onto the cookie first.', first:'07'},
    kids:    {headline:'Your kid picks a picture on your phone. It lands on paper. They draw it.', first:'06'},
    banners: {headline:'Paint the banner yourself: project the design, trace it, paint it.', first:'01'}
  };
  var money = function(v){ return '$' + v.toFixed(2); };
  var $ = function(s,r){ return (r||document).querySelector(s); };
  var $$ = function(s,r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };

  /* ---------- Angle (?angle=cookies|kids|banners) ---------- */
  var angleKey = (new URLSearchParams(location.search).get('angle') || '').toLowerCase();
  var angle = ANGLES[angleKey] || null;
  if (angle) {
    $('[data-angle-headline]').textContent = angle.headline;
    var fi = IMAGES.findIndex(function(i){ return i.n === angle.first; });
    if (fi > 0) IMAGES.unshift(IMAGES.splice(fi,1)[0]);
    ['[data-review-order]','[data-use-order]'].forEach(function(sel){
      var list = $(sel), hit = list && list.querySelector('[data-angle="'+angleKey+'"]');
      if (hit) list.insertBefore(hit, list.firstElementChild);
    });
  }

  /* ---------- Gallery: swipeable track + arrows + thumbnails ----------
     One slide fills the card at a time. Swipe is the browser's own scroll-snap,
     the arrows and the thumbnails both just scroll the track, and whatever moved
     it last, the scroll position is the single source of truth for which image
     is showing. object-fit:contain on white, so nothing is ever cropped. ----- */
  var track = $('[data-track]'), dots = $('[data-dots]'), gIdx = 0;
  var src = function(img, w){ return CDN + img.n + '.png?v=1789447596&width=' + w; };

  IMAGES.forEach(function(img, i){
    var s = document.createElement('div');
    s.className = 'g-slide';
    s.innerHTML = '<img src="' + src(img, 1200) + '" srcset="' + src(img, 600) + ' 600w, ' + src(img, 900) + ' 900w, ' + src(img, 1200) + ' 1200w"'
      + ' sizes="(min-width:900px) 560px, 92vw" alt="' + img.alt.replace(/"/g, '&quot;') + '" width="900" height="900"'
      + (i === 0 ? ' fetchpriority="high"' : ' loading="lazy"') + '>';
    track.appendChild(s);

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'g-thumb';
    b.setAttribute('role', 'tab');
    b.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + IMAGES.length);
    b.innerHTML = '<img src="' + src(img, 180) + '" alt="" width="90" height="90"' + (i < 4 ? '' : ' loading="lazy"') + '>';
    b.addEventListener('click', function(){ go(i); });
    dots.appendChild(b);
  });

  var slides = $$('.g-slide', track), thumbs = $$('button', dots);
  var prevBtn = $('[data-prev]'), nextBtn = $('[data-next]');

  function go(i){
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    sync(i);                       // paint straight away; the scroll handler confirms it
  }

  function nearest(){
    var base = track.scrollLeft, best = 0, bestD = Infinity;
    slides.forEach(function(s, i){
      var d = Math.abs(s.offsetLeft - slides[0].offsetLeft - base);
      if (d < bestD){ bestD = d; best = i; }
    });
    return best;
  }

  function sync(i){
    gIdx = (i == null) ? nearest() : i;
    thumbs.forEach(function(b, k){
      b.setAttribute('aria-selected', k === gIdx ? 'true' : 'false');
      b.tabIndex = k === gIdx ? 0 : -1;
    });
    prevBtn.disabled = gIdx === 0;
    nextBtn.disabled = gIdx === slides.length - 1;
  }

  track.addEventListener('scroll', function(){ sync(); }, { passive: true });
  prevBtn.addEventListener('click', function(){ go(gIdx - 1); });
  nextBtn.addEventListener('click', function(){ go(gIdx + 1); });

  // Left/right keys work on the image itself and on the thumbnail strip.
  function arrowKeys(e, focusThumb){
    var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
    if (!d) return;
    e.preventDefault();
    var next = Math.max(0, Math.min(slides.length - 1, gIdx + d));
    go(next);
    if (focusThumb) thumbs[next].focus();
  }
  dots.addEventListener('keydown', function(e){ arrowKeys(e, true); });
  track.addEventListener('keydown', function(e){ arrowKeys(e, false); });

  sync(0);

  /* ---------- Pack selection ---------- */
  var current = '1';
  function render(){
    var p = PACKS[current], save = p.compare ? p.compare - p.price : 0;
    $('[data-price]').textContent = money(p.price);
    var cmp = $('[data-compare]'), sv = $('[data-save]');
    if (p.compare){ cmp.textContent = money(p.compare); cmp.hidden = false; sv.textContent = 'Save ' + money(save); sv.hidden = false; }
    else { cmp.hidden = true; sv.hidden = true; }
    $('[data-sel-name]').textContent = p.name;
    $('[data-sel-price]').textContent = money(p.price);
    $('[data-sel-save]').textContent = p.compare ? '(save ' + money(save) + ')' : '';
    $('[data-sticky-name]').textContent = p.name + ' · ' + money(p.price);
    $('[data-sticky-sub]').textContent = p.compare ? 'You save ' + money(save) : '30-day money-back guarantee';
  }
  /* A link can name a variant (?variant=123, e.g. from a collection card, an ad, or a
     shopping feed). Select that pack so the page shows the price the link promised. */
  (function preselectFromUrl() {
    var wanted = new URLSearchParams(location.search).get('variant');
    if (!wanted) return;
    var key = Object.keys(PACKS).filter(function (k) { return String(PACKS[k].id) === String(wanted); })[0];
    if (!key) return;
    var radio = $('input[name="pack"][value="' + key + '"]');
    if (!radio) return;
    radio.checked = true;
    current = key;
  })();

  $$('input[name="pack"]').forEach(function(r){
    r.addEventListener('change', function(){ if (r.checked){ current = r.value; render(); } });
  });
  render();

  /* ---------- Cart drawer + real Shopify cart ----------
     On the store (any Shopify-hosted page) every Add to Cart click:
       1. POSTs /cart/add.js with the selected pack's variant ID,
       2. reads /cart.js and, if needed, sets that pack to qty 1 and removes the other packs
          of THIS product (other products stay), then reads /cart.js again,
       3. renders the drawer (lines, prices, savings, total, count) from Shopify's cart JSON only.
     Compare-at prices aren't in /cart.js, so they come from Shopify's /products/<handle>.js.
     Checkout goes to /checkout. Off the store (a local preview) there is no cart to call, so the
     drawer shows the selected pack and Checkout uses a cart permalink on the store. */
  var STORE_ORIGIN = 'https://getinsideline.com';   // change when the store domain changes
  var PACK_IDS = Object.keys(PACKS).map(function(k){ return PACKS[k].id; });
  var onStore = !!(window.Shopify && window.Shopify.shop) || location.origin === STORE_ORIGIN || /\.myshopify\.com$/.test(location.hostname);
  var drawer = $('[data-drawer]'), lastFocus = null;
  var errBox = $('.atc-error');
  var compareAt = {}, fetchedHandles = {};        // variant id -> compare_at_price (cents), from Shopify
  var cents = function(c){ return money(c / 100); };

  function api(url, body){
    var opts = body ? {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(body)} : {headers:{'Accept':'application/json'}};
    return fetch(url, opts).then(function(r){
      return r.json().catch(function(){ return {}; }).then(function(j){
        if (!r.ok) throw new Error(j.description || j.message || ('Cart request failed (' + r.status + ')'));
        return j;
      });
    });
  }

  function loadCompareAt(cart){
    var handles = cart.items.map(function(it){ return it.handle; })
      .filter(function(h, i, a){ return h && a.indexOf(h) === i && !fetchedHandles[h]; });
    return Promise.all(handles.map(function(h){
      return api('/products/' + h + '.js').then(function(p){
        fetchedHandles[h] = true;
        p.variants.forEach(function(v){ compareAt[v.id] = v.compare_at_price; });
      }).catch(function(){ fetchedHandles[h] = true; });
    })).then(function(){ return cart; });
  }

  function syncShopifyCart(p){
    // Add FIRST, so a failed add never empties the cart.
    return api('/cart/add.js', {items: [{id: p.id, quantity: 1}]})
      .then(function(){ return api('/cart.js'); })
      .then(function(cart){
        var updates = {};
        cart.items.forEach(function(it){
          if (it.variant_id === p.id){ if (it.quantity !== 1) updates[it.key] = 1; }
          else if (PACK_IDS.indexOf(it.variant_id) > -1) updates[it.key] = 0;   // other pack of this product
        });
        return Object.keys(updates).length ? api('/cart/update.js', {updates: updates}).then(function(){ return api('/cart.js'); }) : cart;
      })
      .then(loadCompareAt);
  }

  function previewCart(){                           // off-store only: mirrors the cart.js shape
    var p = PACKS[current];
    compareAt[p.id] = Math.round(p.compare * 100);
    return {item_count:1, total_price:Math.round(p.price * 100), items:[{
      variant_id:p.id, quantity:1, product_title:'Inside Line™ Art Tracing Projector', variant_title:p.name,
      final_line_price:Math.round(p.price * 100), original_line_price:Math.round(p.price * 100),
      image:CDN + '04.png?v=1789447596'
    }]};
  }

  function el(tag, cls, text){ var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }

  function renderDrawer(cart){
    var lines = $('[data-d-lines]'), saved = 0, packLines = [];
    lines.textContent = '';
    cart.items.forEach(function(it){
      var wasEach = Math.max(compareAt[it.variant_id] || 0, it.original_line_price / it.quantity);
      var was = wasEach * it.quantity;
      if (was > it.final_line_price) saved += was - it.final_line_price;
      if (PACK_IDS.indexOf(it.variant_id) > -1) packLines.push(it);

      var row = el('div', 'd-line');
      row.setAttribute('data-variant-id', it.variant_id);
      var img;                                     // products without an image get a blank tile, so columns stay aligned
      if (it.image){ img = el('img'); img.alt = ''; img.width = 72; img.height = 72; img.src = it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200'; }
      else img = el('span', 'd-noimg');
      var info = el('div');
      info.appendChild(el('b', null, it.product_title));
      if (it.variant_title) info.appendChild(el('span', null, it.variant_title));

      // Quantity stepper. Each button carries the quantity it would set, so the click
      // handler stays a plain /cart/change.js call and the cart's own reply is what redraws.
      var name = it.product_title + (it.variant_title ? ' (' + it.variant_title + ')' : '');
      var qty = el('div', 'd-qty');
      qty.setAttribute('role', 'group');
      qty.setAttribute('aria-label', 'Quantity for ' + name);
      var minus = el('button', 'd-qty__btn', '\u2212'); minus.type = 'button';
      minus.setAttribute('aria-label', 'Decrease quantity of ' + name);
      minus.setAttribute('data-qty-key', it.key || '');
      minus.setAttribute('data-qty', it.quantity - 1);
      if (it.quantity <= 1) minus.disabled = true;          // use Remove to take the last one out
      var count = el('span', 'd-qty__n', String(it.quantity));
      count.setAttribute('aria-live', 'polite');
      var plus = el('button', 'd-qty__btn', '+'); plus.type = 'button';
      plus.setAttribute('aria-label', 'Increase quantity of ' + name);
      plus.setAttribute('data-qty-key', it.key || '');
      plus.setAttribute('data-qty', it.quantity + 1);
      qty.appendChild(minus); qty.appendChild(count); qty.appendChild(plus);

      var rm = el('button', 'd-remove', 'Remove'); rm.type = 'button';
      rm.setAttribute('data-remove-key', it.key || '');
      rm.setAttribute('aria-label', 'Remove ' + name + ' from cart');
      var actions = el('div', 'd-actions');
      actions.appendChild(qty); actions.appendChild(rm);
      info.appendChild(actions);
      var price = el('div', 'd-price');
      price.appendChild(el('b', null, cents(it.final_line_price)));
      if (was > it.final_line_price) price.appendChild(el('s', null, cents(was)));
      row.appendChild(img); row.appendChild(info); row.appendChild(price);
      lines.appendChild(row);
    });
    var empty = !cart.items.length;
    $('[data-d-empty]').hidden = !empty;
    $('[data-d-foot]').hidden = empty;
    var s = $('[data-d-save]');
    s.hidden = !saved;
    s.textContent = saved ? 'You’re saving ' + cents(saved) + (packLines.length === 1 && packLines[0].variant_title ? ' with the ' + packLines[0].variant_title : '') : '';
    $('[data-d-total]').textContent = cents(cart.total_price);
    $('[data-checkout]').href = onStore ? '/checkout' : STORE_ORIGIN + '/cart/' + PACKS[current].id + ':1';
    setCount(cart.item_count);
  }

  function openCart(){
    lastFocus = document.activeElement;
    document.body.classList.add('cart-open'); drawer.setAttribute('aria-hidden','false');
    $('.d-close', drawer).focus();
  }
  function closeCart(){
    document.body.classList.remove('cart-open'); drawer.setAttribute('aria-hidden','true');
    if (lastFocus) lastFocus.focus();
  }
  $$('[data-open-cart]').forEach(function(b){
    b.addEventListener('click', function(){
      if (!onStore){ openCart(); return; }
      api('/cart.js').then(loadCompareAt).then(function(cart){ renderDrawer(cart); openCart(); })
        .catch(function(){ openCart(); });
    });
  });
  $$('[data-close-cart]').forEach(function(b){ b.addEventListener('click', closeCart); });

  /* Remove one line or clear the whole cart, then re-render from Shopify's cart */
  function refreshCart(req){
    return req.then(function(){ return onStore ? api('/cart.js').then(loadCompareAt) : {items: [], item_count: 0, total_price: 0}; })
      .catch(function(){ return onStore ? api('/cart.js').then(loadCompareAt) : {items: [], item_count: 0, total_price: 0}; })
      .then(function(cart){ renderDrawer(cart); $('.d-close', drawer).focus(); });
  }
  drawer.addEventListener('click', function(e){
    var q = e.target.closest('[data-qty-key]');
    if (q) {
      var want = parseInt(q.getAttribute('data-qty'), 10);
      if (!(want > 0)) return;                              // 0 is Remove's job, not the stepper's
      q.disabled = true;
      refreshCart(onStore ? api('/cart/change.js', {id: q.getAttribute('data-qty-key'), quantity: want}) : Promise.resolve());
      return;
    }
    var rm = e.target.closest('[data-remove-key]');
    if (rm) { rm.disabled = true; refreshCart(onStore ? api('/cart/change.js', {id: rm.getAttribute('data-remove-key'), quantity: 0}) : Promise.resolve()); return; }
    var clr = e.target.closest('[data-clear-cart]');
    if (clr) { clr.disabled = true; refreshCart(onStore ? api('/cart/clear.js', {}) : Promise.resolve()).then(function(){ clr.disabled = false; }); }
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && document.body.classList.contains('cart-open')) closeCart(); });

  function showError(msg){ errBox.textContent = msg; errBox.hidden = false; errBox.scrollIntoView({block:'nearest'}); }
  function setCount(n){ $('.cart-count').textContent = n; }   // the header pill always shows the count, 0 included

  function addToCart(btn){
    var p = PACKS[current];
    errBox.hidden = true;
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy','true');
    if (!onStore){                                   // preview / other host: checkout link carries the pack
      btn.removeAttribute('aria-busy'); renderDrawer(previewCart()); openCart(); return;
    }
    syncShopifyCart(p).then(function(cart){
      btn.removeAttribute('aria-busy');
      renderDrawer(cart); openCart();
    }).catch(function(err){
      btn.removeAttribute('aria-busy');
      showError('That didn’t add to your cart: ' + err.message + '. Please try again.');
    });
  }
  $$('[data-atc]').forEach(function(b){ b.addEventListener('click', function(){ addToCart(b); }); });

  if (onStore) api('/cart.js').then(function(cart){ setCount(cart.item_count); }).catch(function(){});
  // /cart (e.g. the bag icon at checkout) shows this page with the cart drawer open
  if (onStore && /^\/cart\/?$/.test(location.pathname)) api('/cart.js').then(loadCompareAt).then(function(cart){ renderDrawer(cart); openCart(); }).catch(function(){});

  /* Express buttons: add the selected pack, then go straight to Shopify checkout,
     where the shopper's wallet (Shop Pay / Apple Pay / Google Pay / PayPal) completes payment. */
  function expressCheckout(btn){
    var p = PACKS[current];
    errBox.hidden = true;
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy','true');
    if (!onStore){ window.location.href = STORE_ORIGIN + '/cart/' + p.id + ':1'; return; }
    syncShopifyCart(p).then(function(){ window.location.href = '/checkout'; })
      .catch(function(err){ btn.removeAttribute('aria-busy'); showError('That didn’t go through: ' + err.message + '. Please try again.'); });
  }
  $$('[data-express]').forEach(function(b){ b.addEventListener('click', function(){ expressCheckout(b); }); });

  /* ---------- Site menu (header, left): jump links + help pages ---------- */
  var menu = $('[data-menu]'), menuBtn = $('[data-open-menu]'), menuLastFocus = null;
  function openMenu(){
    if (document.body.classList.contains('cart-open')) closeCart();
    menuLastFocus = document.activeElement;
    document.body.classList.add('menu-open');
    menu.removeAttribute('inert'); menu.setAttribute('aria-hidden','false'); menuBtn.setAttribute('aria-expanded','true');
    $('.nav-close', menu).focus();
  }
  function closeMenu(returnFocus){
    document.body.classList.remove('menu-open');
    menu.setAttribute('inert',''); menu.setAttribute('aria-hidden','true'); menuBtn.setAttribute('aria-expanded','false');
    if (returnFocus !== false) (menuLastFocus && menuLastFocus !== document.body ? menuLastFocus : menuBtn).focus();   // Safari doesn't focus buttons on click
  }
  menuBtn.addEventListener('click', openMenu);
  $$('[data-close-menu]').forEach(function(b){ b.addEventListener('click', function(){ closeMenu(); }); });
  $$('a', menu).forEach(function(a){ a.addEventListener('click', function(){ closeMenu(false); }); });   // jump links: close, then the browser scrolls to the section
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && document.body.classList.contains('menu-open')) closeMenu(); });

  /* ---------- Demo video player: play/pause, skip 5 s, seek, full screen. No volume control: the file has no sound. ---------- */
  var player = $('[data-player]');
  if (player) {
    var demo = $('video', player), toggle = $('[data-player-toggle]', player), seek = $('[data-player-seek]', player);
    var timeEl = $('[data-player-time]', player), fsBtn = $('[data-player-fs]', player), userPaused = false;
    var fmt = function(s){ s = Math.max(0, Math.floor(s || 0)); return Math.floor(s / 60) + ':' + ('0' + s % 60).slice(-2); };
    var syncUI = function(){
      var playing = !demo.paused;
      toggle.setAttribute('aria-label', playing ? 'Pause' : 'Play');
      $('use', toggle).setAttribute('href', playing ? '#i-pause' : '#i-play');
      if (demo.duration) { seek.value = Math.round(demo.currentTime / demo.duration * 1000); timeEl.textContent = fmt(demo.currentTime) + ' / ' + fmt(demo.duration); }
    };
    var playNow = function(){ var p = demo.play(); if (p && p.catch) p.catch(function(){}); };
    ['play', 'pause', 'timeupdate', 'loadedmetadata', 'seeked'].forEach(function(ev){ demo.addEventListener(ev, syncUI); });
    toggle.addEventListener('click', function(){ if (demo.paused) { userPaused = false; playNow(); } else { userPaused = true; demo.pause(); } });
    demo.addEventListener('click', function(){ toggle.click(); });
    $$('[data-player-skip]', player).forEach(function(b){ b.addEventListener('click', function(){
      if (demo.readyState < 1) { demo.preload = 'auto'; demo.load(); }
      var d = demo.duration || 0, t = demo.currentTime + Number(b.getAttribute('data-player-skip'));
      demo.currentTime = d ? Math.min(Math.max(t, 0), d - 0.1) : Math.max(t, 0);
    }); });
    seek.addEventListener('input', function(){ if (demo.duration) demo.currentTime = seek.value / 1000 * demo.duration; });
    var fsEl = function(){ return document.fullscreenElement || document.webkitFullscreenElement; };
    fsBtn.addEventListener('click', function(){
      if (fsEl()) { (document.exitFullscreen || document.webkitExitFullscreen).call(document); return; }
      if (player.requestFullscreen) player.requestFullscreen().catch(function(){ if (demo.webkitEnterFullscreen) demo.webkitEnterFullscreen(); });
      else if (player.webkitRequestFullscreen) player.webkitRequestFullscreen();
      else if (demo.webkitEnterFullscreen) demo.webkitEnterFullscreen();   // iPhone: native full-screen player
    });
    var fsChange = function(){ var on = !!fsEl(); fsBtn.setAttribute('aria-label', on ? 'Exit full screen' : 'Full screen'); $('use', fsBtn).setAttribute('href', on ? '#i-compress' : '#i-expand'); };
    document.addEventListener('fullscreenchange', fsChange); document.addEventListener('webkitfullscreenchange', fsChange);
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) demo.preload = 'metadata';   // no autoplay; the controls start it
    else new IntersectionObserver(function(es){ es.forEach(function(e){
      if (e.isIntersecting) { if (!userPaused) playNow(); }
      else if (!demo.paused && !fsEl()) demo.pause();
    }); }, {rootMargin: '200px 0px'}).observe(player);
    syncUI();
  }

  /* ---------- Header links (wide screens): underline the section being read ---------- */
  var spyLinks = $$('[data-spy]');
  if (spyLinks.length && 'IntersectionObserver' in window) {
    var spyTargets = spyLinks.map(function(a){ var id = a.getAttribute('data-spy'); return id === 'overview' ? $('section.buy') : document.getElementById(id); });
    var spy = new IntersectionObserver(function(es){ es.forEach(function(e){
      if (!e.isIntersecting) return;
      var i = spyTargets.indexOf(e.target);
      spyLinks.forEach(function(a, j){ if (j === i) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
    }); }, {rootMargin: '-40% 0px -55% 0px'});
    spyTargets.forEach(function(t){ if (t) spy.observe(t); });
  }

  /* ---------- Sale deadline: counts down to a real end time, then removes itself ---------- */
  var saleEl = $('[data-sale-ends]');
  if (saleEl) {
    var endsAt = new Date(saleEl.getAttribute('data-sale-ends')).getTime();
    var countEl = $('[data-sale-countdown]', saleEl);
    var tickSale = function(){
      var left = endsAt - Date.now();
      if (!(left > 0)) { saleEl.hidden = true; if (saleTimer) clearInterval(saleTimer); return; }
      var h = Math.floor(left / 3600000), m = Math.floor(left % 3600000 / 60000), s = Math.floor(left % 60000 / 1000);
      countEl.textContent = (h ? h + 'h ' : '') + m + 'm ' + ('0' + s).slice(-2) + 's';
      saleEl.hidden = false;
    };
    var saleTimer = setInterval(tickSale, 1000);
    tickSale();
  }

  /* ---------- Back to top: appears after a header jump or scrolling past ~700px ---------- */
  var toTop = $('[data-to-top]');
  if (toTop) {
    var toTopShown = null;
    var updTop = function(){
      var show = window.scrollY > 700;
      if (show === toTopShown) return;
      toTopShown = show;
      toTop.classList.toggle('show', show); toTop.setAttribute('aria-hidden', show ? 'false' : 'true'); toTop.tabIndex = show ? 0 : -1;
    };
    window.addEventListener('scroll', updTop, {passive: true});   // cheap: compares one number, touches the DOM only when the state flips
    window.addEventListener('hashchange', updTop);
    toTop.addEventListener('click', function(){
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({top: 0, behavior: reduce ? 'auto' : 'smooth'});
      if (location.hash) history.replaceState(null, '', location.pathname + location.search);   // drop #reviews etc., keep ?angle=
      var logo = $('.hdr .logo'); if (logo) logo.focus({preventScroll: true});
    });
    updTop();
  }

  /* ---------- Sticky bar: show once the main button has scrolled away ---------- */
  var sticky = $('[data-sticky]'), mainBtn = $('#atc-main'), finalSec = $('#order');
  if ('IntersectionObserver' in window){
    var mainVisible = true, finalVisible = false;
    var upd = function(){ var show = !mainVisible && !finalVisible; sticky.classList.toggle('show', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true'); $('button', sticky).tabIndex = show ? 0 : -1; };
    new IntersectionObserver(function(es){ mainVisible = es[0].isIntersecting || es[0].boundingClientRect.top > 0; upd(); }).observe(mainBtn);
    new IntersectionObserver(function(es){ finalVisible = es[0].isIntersecting; upd(); }, {rootMargin:'0px 0px -20% 0px'}).observe(finalSec);

    /* ---------- Section reveal (content visible without JS) ---------- */
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.remove('is-hidden'); io.unobserve(e.target); } }); }, {rootMargin:'0px 0px -8% 0px'});
    $$('.reveal').forEach(function(el){ if (el.getBoundingClientRect().top > window.innerHeight){ el.classList.add('is-hidden'); io.observe(el); } });
  }
})();
